var _circle, _mask, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.9545,
    cy: 10.9545,
    r: 6.95455,
    fill: "white"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 14,
    height: 14
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10.9545,
    cy: 10.9545,
    r: 6.95455,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 13.7576,
    width: 13.9091,
    height: 5.15151,
    fill: "#DB5F7B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 8.60608,
    width: 13.9091,
    height: 5.15151,
    fill: "#6FB1D6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 3.45456,
    width: 13.9091,
    height: 5.15151,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.97168 8.7623V13.4138C7.97168 14.2494 8.30266 14.9988 8.8458 15.5501C9.38045 16.0928 10.1358 16.4373 10.9505 16.4373C11.7737 16.4373 12.5205 16.0928 13.0551 15.5501C13.5983 14.9988 13.9292 14.2494 13.9292 13.4138V8.7623H7.97168Z",
    fill: "#DB5F7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.12666 9.20457C9.13708 9.31134 9.14072 9.56395 9.07197 9.7202C8.98604 9.91551 9.32197 10.8061 9.61104 10.8608C9.84229 10.9046 9.87406 11.103 9.86104 11.1968C10.0954 10.8869 10.4876 10.1702 10.1813 9.7827C10.0348 9.59732 9.89634 9.48975 9.79826 9.41358C9.64007 9.29072 9.58702 9.24952 9.7751 9.0952C10.0798 8.8452 10.6735 9.32957 10.7048 9.55613C10.7186 9.65613 10.7933 9.96313 10.8717 10.2857C10.8965 10.3878 10.9218 10.4915 10.9456 10.5906C10.9693 10.4915 10.9946 10.3878 11.0194 10.2857C11.0979 9.96313 11.1725 9.65613 11.1863 9.55613C11.2176 9.32957 11.8113 8.8452 12.116 9.0952C12.3041 9.24952 12.251 9.29072 12.0929 9.41358C11.9948 9.48975 11.8563 9.59732 11.7098 9.7827C11.4035 10.1702 11.7957 10.8869 12.0301 11.1968C12.0171 11.103 12.0488 10.9046 12.2801 10.8608C12.5691 10.8061 12.9051 9.91551 12.8191 9.7202C12.7504 9.56395 12.754 9.31134 12.7645 9.20457C13.2969 9.13464 13.452 9.7202 13.6316 10.4702C13.8113 11.2202 13.7488 12.478 13.6707 12.6421C13.6304 12.7268 13.6025 13.0656 13.5764 13.3832C13.552 13.6807 13.5291 13.9596 13.4988 13.9936C13.4363 14.0639 13.2332 13.9389 13.1082 13.7749C13.0082 13.6436 12.8165 13.116 12.7332 12.8686C12.2207 12.6749 12.077 12.366 12.0691 12.2358C11.8868 12.4624 11.6238 12.9061 12.0301 12.8686C12.5379 12.8218 12.7332 13.2827 12.4363 13.6577C12.1988 13.9577 11.8165 13.8139 11.6551 13.7046C11.4728 13.6681 11.1613 13.653 11.3738 13.8843C11.6395 14.1733 12.0301 15.5249 11.9754 15.6577C11.9318 15.7636 11.2735 16.0234 10.947 16.141V16.1421L10.9456 16.1416L10.9441 16.1421V16.141C10.6176 16.0234 9.95935 15.7636 9.91572 15.6577C9.86104 15.5249 10.2517 14.1733 10.5173 13.8843C10.7298 13.653 10.4183 13.6681 10.236 13.7046C10.0746 13.8139 9.69229 13.9577 9.45479 13.6577C9.15791 13.2827 9.35322 12.8218 9.86104 12.8686C10.2673 12.9061 10.0043 12.4624 9.82197 12.2358C9.81416 12.366 9.67041 12.6749 9.15791 12.8686C9.07458 13.116 8.88291 13.6436 8.78291 13.7749C8.65791 13.9389 8.45479 14.0639 8.39229 13.9936C8.36206 13.9596 8.33914 13.6807 8.31469 13.3832C8.28859 13.0656 8.26075 12.7268 8.22041 12.6421C8.14229 12.478 8.07979 11.2202 8.25947 10.4702C8.43916 9.7202 8.59423 9.13464 9.12666 9.20457Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.82568 10.7115V12.4773C9.82568 12.796 9.95298 13.0803 10.1567 13.287C10.3603 13.4938 10.6489 13.623 10.9544 13.623C11.2684 13.623 11.5485 13.4938 11.7521 13.287C11.9558 13.0803 12.0831 12.796 12.0831 12.4773V10.7115H9.82568Z",
    fill: "#DB5F7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.82568 11.9002H10.7847V10.7115H11.1241V11.9002H12.0831V12.2447H11.1326V13.6144C11.0817 13.623 11.0223 13.6316 10.9629 13.6316C10.912 13.6316 10.8526 13.6316 10.7932 13.6144V12.2534H9.82568V11.9002Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.3882,
    y: 10.9858,
    width: 0.480469,
    height: 0.648438,
    rx: 0.240234,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.064,
    y: 10.9858,
    width: 0.480469,
    height: 0.648438,
    rx: 0.240234,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.3882,
    y: 12.5132,
    width: 0.480469,
    height: 0.648438,
    rx: 0.240234,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.064,
    y: 12.5132,
    width: 0.480469,
    height: 0.648438,
    rx: 0.240234,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.41846,
    y: 13.4068,
    width: 0.480469,
    height: 1.35547,
    rx: 0.240234,
    transform: "rotate(23.0213 9.41846 13.4068)",
    fill: "#F3CE49"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.480469,
    height: 1.35547,
    rx: 0.240234,
    transform: "matrix(-0.92036 0.391073 0.391073 0.92036 12.5259 13.4146)",
    fill: "#F3CE49"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.87451,
    y: 9.07874,
    width: 0.674767,
    height: 0.839844,
    rx: 0.337384,
    transform: "rotate(58.5818 9.87451 9.07874)",
    fill: "#F3CE49"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.674767,
    height: 0.839844,
    rx: 0.337384,
    transform: "matrix(-0.52128 0.853386 0.853386 0.52128 11.9077 9.07874)",
    fill: "#F3CE49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.30615 7.07956C9.30615 6.52727 9.75387 6.07956 10.3062 6.07956H12.0171C12.5694 6.07956 13.0171 6.52727 13.0171 7.07956V7.21237C13.0171 7.76466 12.5694 8.21237 12.0171 8.21237H10.3062C9.75387 8.21237 9.30615 7.76466 9.30615 7.21237V7.07956Z",
    fill: "#DB5F7B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.30615,
    y: 7.24362,
    width: 3.71094,
    height: 0.96875,
    rx: 0.484375,
    fill: "#F3CE49"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSr);
export default __webpack_public_path__ + "static/media/sr.5693f9de4516074608c17bc1c2b7117d.svg";
export { ForwardRef as ReactComponent };